import { useMutation, useQueryClient } from '@tanstack/react-query'
import { strapiPost } from '@/lib/strapi'

export function useCreateComment() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ bookingDocumentId, text }: { bookingDocumentId: string; text: string }) =>
      strapiPost('/api/comments', {
        data: {
          booking: bookingDocumentId,
          text,
          role: 'restaurant',
          sendNotification: false,
          bookosId: `manual-${Date.now()}`,
        },
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['booking'] }),
  })
}
